// src/components/SidebarPortal.tsx
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { IoMdCloseCircle } from 'react-icons/io';
import './SidebarPortal.scss';

interface SidebarPortalProps {
  open: boolean;
  onClose: () => void;
  position: 'left' | 'right';
  heading?: string;
  children?: React.ReactNode;
  renderHeaderRightSideContenet?:React.ReactNode;
}

const SidebarPortal: React.FC<SidebarPortalProps> = ({ open, onClose, position, heading, children,renderHeaderRightSideContenet }) => {
  const [animation, setAnimation] = useState('');

  useEffect(() => {
    if (open) {
      setAnimation('open');
    } else if (!open && animation === 'open') {
      setAnimation('close');
      setTimeout(() => {
        setAnimation('');
      }, 300); // Timeout should match the CSS transition time
    }
  }, [open]);

  if (!open && animation !== 'close') return null;

  // In SidebarPortal component
  return ReactDOM.createPortal(
    <div className={`sidebar-modal ${position} ${animation}`}>
      <div className="sidebar-content">
        <div className="header">
          <p>{heading || "Default Heading"}</p>
          <span>
            <span>
              {renderHeaderRightSideContenet}
            </span>
            <span onClick={() => {
              setAnimation('close');
              setTimeout(onClose, 300); // Ensure onClose is called after animation
            }}>
              <IoMdCloseCircle className="closeIcon" />
            </span>
          </span>

        </div>
        <div className="children-header">
          {children}
        </div>
      </div>
    </div>,
    document.getElementById('modal-root') as HTMLElement
  );
};

export default SidebarPortal;
